module.exports = __webpack_public_path__ + "static/img/empty.21802478.png";